/**
 * Entry dla szablonu page-contact.php — osobny bundle (cache / dalszy podział kodu).
 * Logika startu jest współdzielona z main przez vue-app-bootstrap.js.
 */
import '../webpack-public-path';

import { bootstrapVueApp } from '../vue-app-bootstrap';

bootstrapVueApp();
